<template>
  <Headline :subtitle="'Maßgeschneiderte Software auf dem nächsten Level'">KI-first</Headline>
  <div class="pt-4 md:pt-8 xl:pt-16 pb-32 lg:my-5">
    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 mb-8">
      
      <div class="lg:text-left mb-16 max-w-3xl mx-auto">
        <h2 class="h1 mb-4">KI in 2026</h2>
        <p class="my-4">Um ehrlich zu sein: Als Gründer von Softwerkstatt habe ich KI und Agents lange unterschätzt. Primär weil ich keine überzeugenden Use Cases in maßgeschneiderter Software erkannt habe. Bis letzten Sommer, als mir klar wurde, dass bei Tesla jeder Softwareentwickler 50% seiner Arbeitszeit mit der Integration von KI in deren interne Software verbringen soll. Was gerade passiert: Zum ersten Mal ist das Verhältnis aus Wertschöpfung zu Aufwand nicht nur besser geworden – es eröffnet Lösungen, die ich vorher schlicht nicht auf dem Schirm hatten. Und genau dort beginnt Softwerkstatt heute.</p>
        <p class="my-4">KI-first bedeutet für uns nicht „GenAI überall rein“. Es bedeutet: den größten Hebel durch intelligente Automatisierung zu finden, schnell zu prototypisieren und den Effekt messbar zu machen. KI ist die Chance, Wissensarbeit zu skalieren und zu standardisieren: Weniger Copy-Paste, weniger Rückfragen, weniger „wo finde ich das?“ – mehr Fokus auf das, was wirklich zählt.</p>
        <p class="my-4">Genau hier schließt Softwerkstatt die Lücke zwischen individuell entwickelter Software und den standardisierten AI-APIs von OpenAI & Co.: Wir übersetzen Möglichkeiten in robuste Systeme, die im Alltag funktionieren – mit sauberen Datenflüssen, klaren Verantwortlichkeiten und echter Integration in Eure Prozesse: Engineering-first, pragmatisch, sicher, wartbar – und mit dem Ziel der Value-Creation.</p>
        <p class="my-4">Wir lieben nicht die Magic, wenn ein LLM unsere Erwartungen an einen generierten Text übertrifft. Wir lieben den Moment, wenn Euer Team sagt: „Das hat mir heute zwei Stunden gespart.“ Oder: „Es fühlt sich an, als wäre es schon immer so gewesen.“</p>
        <p class="my-4">Wir bauen eine Zukunft, in der Arbeit leichter wird, weil Systeme endlich mitdenken. Eine Zukunft, in der jedes Unternehmen – nicht nur Big Tech – Zugriff auf moderne Intelligenz hat: verständlich, anpassbar, souverän.</p>
        <p class="my-4">— Dario, Gründer von Softwerkstatt</p>
      </div>

    </div>

    <!-- <Container>
      <h2 class="h1 mb-8">Mehr über unser AI Lab</h2>
      <p class="mb-6 text-left max-w-3xl mx-auto">Interessierst du dich für praktische KI-Projekte? Besuche unser <router-link to="/innovation-lab">Innovation Lab</router-link>, wo wir an den neuesten KI-Technologien arbeiten, oder erfahre mehr über unsere <router-link to="/ki-und-.net">KI mit .NET Entwicklung</router-link>.</p>
    </Container> -->

    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 mt-16">
      <ContactInfos />
    </div>
    
  </div>
</template>

<script>
import Headline from '../views/Headline.vue'
import ContactInfos from './../views/ContactInfos.vue'
// import Container from './../views/Container.vue'

export default {
  name: 'AIBlog',
  components: {
    Headline,
    ContactInfos,
    // Container
  }
}
</script>

<style scoped>
</style>
